import type { ReactNode } from "react";
import { HugeiconsIcon } from "@hugeicons/react";
import type { IconSvgElement } from "@hugeicons/react";
import { Inline } from "components/layout/reusableLayouts";

interface ValueWithIconProps {
  icon: IconSvgElement;
  children: ReactNode;
}

/**
 * A contact field's value behind its glyph, for the table cells and the detail
 * page's Details card.
 *
 * An absent value renders the placeholder alone, with no glyph: an icon with
 * nothing beside it reads as a field that failed to load rather than one that
 * is blank. The dash is written as an escape because the literal character is
 * banned in this repo (see the root AGENTS.md); the four
 * other placeholders in the app, in TransactionDetails, ReimbursementDetails
 * and CardDetailDrawer, are written the same way.
 */
const EMPTY = "\u2014";

export const ValueWithIcon: React.FC<ValueWithIconProps> = ({
  icon,
  children,
}) => {
  if (!children) return EMPTY;

  return (
    <Inline gap="var(--space-2)" align="center" wrap={false}>
      <HugeiconsIcon icon={icon} size={16} color="var(--color-text-tertiary)" />
      {children}
    </Inline>
  );
};

export default ValueWithIcon;
